import React, { useState } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { getAnalyticsConsent, saveAnalyticsConsent } from '../services/analytics';

export default function AnalyticsConsent() {
  const [consent, setConsent] = useState(getAnalyticsConsent);
  const choose = (enabled) => {
    saveAnalyticsConsent(enabled);
    setConsent(enabled ? 'granted' : 'denied');
  };
  return (
    <Box role="region" aria-label="Preferenze Analytics">
      <Typography variant="h6">Statistiche di utilizzo</Typography>
      <Typography variant="body2">Con il tuo consenso usiamo Google Analytics per misurare schermate, clic e tempi di utilizzo. Non inviamo il contenuto dei moduli o dei messaggi. Puoi cambiare scelta in Privacy e comunicazioni.</Typography>
      <Typography variant="body2" sx={{ mt: 1 }}>Stato: {consent === 'granted' ? 'attivo' : 'disattivato'}</Typography>
      <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
        <Button variant="outlined" onClick={() => choose(false)}>Rifiuta statistiche</Button>
        <Button variant="outlined" onClick={() => choose(true)}>Consenti statistiche</Button>
      </Stack>
    </Box>
  );
}
